import fr from './locales/read-only-auto-generated/fr.json';

type localeDataType = {
  fr: Record<string, string>;
};

const localeData: localeDataType = { fr };

export const getLocalMessages = (): Record<string, string> => localeData.fr;
